import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle2, XCircle, Snowflake } from 'lucide-react';
import { Button } from '../components/ui/button';
import { CheckoutAPI } from '../api';
import { useAuth } from '../context/AuthContext';

export default function CheckoutSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState('checking');
  const [plan, setPlan] = useState('');

  useEffect(() => {
    const sid = params.get('session_id');
    if (!sid) { setState('error'); return; }
    let tries = 0;
    const check = async () => {
      try {
        const res = await CheckoutAPI.verify(sid);
        if (res.active) { setPlan(res.plan); setState('success'); refresh?.(); }
        else if (tries < 5) { tries++; setTimeout(check, 1500); }
        else setState('pending');
      } catch (_) { setState('error'); }
    };
    check();
  }, [params, refresh]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center bg-white border border-slate-200 rounded-2xl p-10 shadow-lg">
        <div className="h-12 w-12 rounded-lg bg-gradient-to-br from-sky-500 to-cyan-500 flex items-center justify-center mx-auto mb-6">
          <Snowflake className="h-6 w-6 text-white" strokeWidth={2.5} />
        </div>
        {state === 'checking' && <>
          <h1 className="font-display text-2xl font-bold">Confirming your subscription</h1>
          <p className="text-slate-500 mt-2">This only takes a moment.</p>
        </>}
        {state === 'success' && <>
          <CheckCircle2 className="h-14 w-14 text-emerald-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold">You're in.</h1>
          <p className="text-slate-500 mt-2">Your ShiftNotes™ {plan} plan is active. Let's build your first evaluation.</p>
          <Button onClick={() => navigate('/app')} className="mt-6 bg-sky-500 hover:bg-sky-600 text-white font-semibold">Open ShiftNotes</Button>
        </>}
        {state === 'pending' && <>
          <h1 className="font-display text-2xl font-bold">Payment received.</h1>
          <p className="text-slate-500 mt-2">Your account will activate shortly. Refresh if you don't see access in a minute.</p>
          <Button onClick={() => navigate('/app')} className="mt-6 bg-sky-500 hover:bg-sky-600 text-white font-semibold">Go to Dashboard</Button>
        </>}
        {state === 'error' && <>
          <XCircle className="h-14 w-14 text-rose-600 mx-auto mb-3" />
          <h1 className="font-display text-2xl font-bold">Something went wrong.</h1>
          <p className="text-slate-500 mt-2">We couldn't confirm your payment. Please try again or contact rob@shiftnotes.io.</p>
          <Button onClick={() => navigate('/pricing')} className="mt-6 bg-sky-500 hover:bg-sky-600 text-white font-semibold">Back to Pricing</Button>
        </>}
      </div>
    </div>
  );
}
